import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { FileTypeEnum } from '@repo/toolkit/types'
import UploadFileInput from '@repo/ui/file-input'
import { DownloadFile } from '@repo/ui/icons'
import { useForm } from 'react-hook-form'

import {
  EventActionTypeEnum,
  eventActionTypeEnumMapping
} from '../../../lib/types/enums/center-event-action/event-action-type.enum'
import { CenterEventActionInput } from '../../../lib/types/models/center-event-action/center-event-action-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import { ControlledListRadioGroup } from '../../elements/inputs/enum-radio-group'
import ValidationButtons from '../../elements/validation-buttons'
import { CENTER_EVENT_ACTION_SCHEMA } from './utils'

type Props = BaseFormProps<CenterEventActionInput> & {
  className?: string
}

const CenterEventActionForm = ({ defaultValues, className, ...validationButtonProps }: Props) => {
  const form = useForm<CenterEventActionInput>({
    resolver: zodResolver(CENTER_EVENT_ACTION_SCHEMA),
    defaultValues,
    mode: FORM_MODE
  })
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={'divide-y divide-white-active'}>
          <div className={cn('flex flex-col gap-4', className)}>
            <ControlledListRadioGroup<CenterEventActionInput, EventActionTypeEnum>
              required
              name={'actionType'}
              label={'Source'}
              list={Object.values(EventActionTypeEnum)}
              mapping={eventActionTypeEnumMapping}
            />
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <ControlledInput {...field} type="text" label="NOM" required />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="description"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <ControlledInput {...field} type="textarea" label="Description" required />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'files'}
              render={({ field }) => (
                <FormItem className={'flex-1'}>
                  <FormControl>
                    <UploadFileInput
                      types={[FileTypeEnum.IMAGE, FileTypeEnum.PDF]}
                      placeholder="Glisser-déposer ou parcourir"
                      placeholderVariant="tag"
                      hasError={!!form.formState.errors.files}
                      placeholderColor={tailwindColors.grey.lighter}
                      icon={DownloadFile}
                      multiple
                      label={'Ajouter une ou plusieurs pièces jointes'}
                      files={field?.value ? field?.value : undefined}
                      onFilesChange={(files) => {
                        field.onChange(files.length === 0 ? null : files)
                      }}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
          <div className="pb-6 px-4">
            <ValidationButtons {...validationButtonProps} />
          </div>
        </div>
      </form>
    </Form>
  )
}

export default CenterEventActionForm
